import { render, staticRenderFns } from "./InvoiceRequest.vue?vue&type=template&id=35c1484c&scoped=true"
import script from "./InvoiceRequest.vue?vue&type=script&lang=js"
export * from "./InvoiceRequest.vue?vue&type=script&lang=js"
import style0 from "./InvoiceRequest.vue?vue&type=style&index=0&id=35c1484c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c1484c",
  null
  
)

export default component.exports